/* eslint-disable react/static-property-placement */
import cx from 'classnames';
import highlightjs from 'highlightjs';
import NewDesignButton from 'modules/common/NewDesignButton';
import False from 'modules/common/Svg/False';
import True from 'modules/common/Svg/True';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {FormattedMessage, injectIntl} from 'react-intl';
import {
  bgCode,
  bgGreen,
  bgRed,
  blankSpace,
  darkBg,
  fillInTheBlank,
  textAlignLeft,
} from './styles.scss';

class QuizFillInTheBlank extends Component {
  constructor(props) {
    super(props);
    this.state = this.constructState(props);
  }

  componentDidMount() {
    this.attachInputs();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // This happens when we have 2 fill in the blank in a row
    if (this.props.question !== nextProps.question) {
      this.detachInputs();
      this.setState(this.constructState(nextProps));
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.question !== prevProps.question) {
      this.attachInputs();
    }
  }

  componentWillUnmount() {
    this.detachInputs();
  }

  constructState = (props) => {
    this.answer = {};
    this.nodes = {};
    const question = props.question
      .split(
        /((?:<\/code>[\s\S]*?)?<\/?pre[\s\S]*?>(?:[\s\S]*?<code[\s\S]*?"(?:language-)?)?)/,
      )
      .map((part, i) => {
        switch (i % 4) {
          case 2: {
            // We extract the language
            const lang = part.substring(0, part.search(/\\?"/));
            // We return highlighted code
            switch (lang) {
              case 'java':
                return `${part.substring(0, part.search(/>/) + 1)}${
                  highlightjs.highlight(
                    lang,
                    part.replace(/^[a-z]+\\?".*?>/, ''),
                    true,
                  ).value
                }`;
              default:
                return `${part}`;
            }
          }
          default:
            return `${part}`;
        }
      })
      .join('')
      // We create mounting point for our future inputs
      .replace(
        /##blank(\d+)#(?:<span[\s\S]*?>)?(\d*)(?:<\/span>)?#/g,
        (match, num, width) => {
          this.nodes[`answer${num}`] = width;
          return `<input name="answer${num}" class="answers-inputs br2 white ${blankSpace}" style="width: ${
            width || 80
          }px" autoFocus="${num === 1}">`;
        },
      );
    // We record the question and the nodes in the state
    return {
      question,
      submited: undefined,
    };
  };

  attachInputs = () => {
    setTimeout(() => {
      const inputs = document.querySelectorAll('.answers-inputs');
      Array.prototype.forEach.call(inputs, (input) => {
        input.addEventListener('input', this.handleChange);
      });
    }, 0);
  };

  detachInputs = () => {
    const inputs = document.querySelectorAll('.answers-inputs');
    Array.prototype.forEach.call(inputs, (input) => {
      input.removeEventListener('input', this.handleChange);
    });
  };

  submit = () => {
    if (this.state.submited === undefined) {
      this.setState({submited: true});
      this.props.checkAnswer(
        Object.entries(this.answer).map(([key, value]) => ({
          [key]: value && value.trim(),
        })),
      );
    }
  };

  handleChange = (event) => {
    this.answer[event.target.name] = event.target.value;
  };

  handleKeyUp = ({keyCode, target: {name}}) => {
    const inputNames = Object.keys(this.state.nodes).sort();
    if (keyCode === 13) {
      const nextInputIndex = inputNames.indexOf(name) + 1;
      if (inputNames.length <= nextInputIndex) {
        this.submit();
      } else {
        const nextInput = document.getElementsByName(
          inputNames[nextInputIndex],
        );
        if (nextInput.length) {
          nextInput[0].focus();
        }
      }
    }
  };

  render() {
    const {formatMessage} = this.props.intl;
    return (
      <div>
        <div>
          <div className="pv3 ph4 lh-copy gray f6 f5-ns fw4 mw8 center tc">
            {this.props.title || (
              <FormattedMessage
                id="fill_correct_answer"
                defaultMessage="Fill in the correct answer in each blank below"
              />
            )}
          </div>
          <div
            className={`pa3 ${darkBg} white tr`}
            data-cy="fill-in-the-blank-title"
          >
            <FormattedMessage
              id="fill_blank_below"
              defaultMessage="Fill in the blank(s) below"
            />
            :
          </div>
          <div className={`pa3 ${bgCode}`}>
            <p
              className={`${fillInTheBlank} ${textAlignLeft} white`}
              dangerouslySetInnerHTML={{
                __html: this.state.question,
              }}
            />
          </div>
        </div>
        <div
          className={cx('pv3 ph4 tr', darkBg, {
            [`${bgRed} flex justify-between items-center flex-row-ns flex-column`]:
              this.props.result !== undefined && !this.props.result,
            [`${bgGreen} flex justify-between items-center flex-row-ns flex-column`]:
              this.props.result !== undefined && this.props.result,
          })}
        >
          <NewDesignButton
            className={cx('pv3 ph4 white br2', {
              'bg-green-light bg-animate hover-bg-green pointer':
                this.state.submited === undefined,
              'bg-moon-gray': this.state.submited !== undefined,
            })}
            active={this.state.submited === undefined}
            onClick={this.submit}
          >
            {formatMessage({id: 'submit_answer'})}
          </NewDesignButton>
          {this.props.result !== undefined && (
            <div className="pa3 silver">
              {this.props.result ? (
                <span className="flex items-center white">
                  <True className="ml3 br-100" />{' '}
                  {formatMessage({id: 'answer_correct'})}.
                </span>
              ) : (
                <span className="flex items-center white">
                  <False color="#fa6d63" className="ml3 br-100" />
                  {formatMessage({id: 'answer_incorrect'})}.
                </span>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

QuizFillInTheBlank.propTypes = {
  checkAnswer: PropTypes.func.isRequired,
  result: PropTypes.bool,
  question: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  intl: PropTypes.object,
};

export default injectIntl(QuizFillInTheBlank);
